
import {React, useState, useContext, useEffect, useRef} from "react"
import {useStyle} from '../../context/styleContext/styleContext'

import axios from 'axios'
import Seo from '../../components/Seo';
//import {toast} from 'react-hot-toast'

import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Divider,
  Grid,
  Paper,
  Rating,
  Stack,
  Typography
} from '@mui/material';
import {
  AudioFileRounded,
  CheckCircleRounded,
  DownloadRounded,
  FlashOnRounded
} from '@mui/icons-material';
import { InfinityReverb_0_0_1 } from "../../ProductInfo";
import { Link as RouterLink } from 'react-router-dom';
import ProductCard from "../../components/ProductCard/ProductCard";
import SubscribeBanner from "../../components/SubscribeBanner/SubscribeBanner";
import HomePageProductCard from "../../components/ProductCard/HomePageProductCard";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import MobileProductCard from "../Plugins/MobileProductCard";
import HomeFeaturedProductCard from "../../components/ProductCard/HomeFeaturedProductCard";


export default function Home(){

  const { style } = useStyle();
  const [height, setHeight] = useState(window.innerHeight)
  const [width, setWidth] = useState(window.setWidth)
  const [dataForAllProducts, setDataForAllProducts] = useState([])

  useEffect(() => {
    function handleResize() {      
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
  }
  
    window.addEventListener('resize', handleResize)
  })

  
const isMobile = width <= 768;


const topContainer = useRef();
    useEffect(() => {
        // To make sure page starts from the top
        topContainer.current.scrollIntoView({ block: "end" });
    }, []);



    const getProductInfo = async (e) => {
      //const productURI = name
     // console.log("get product page info fired")
     //console.log("getting account info..")
      try{
        const {data} = await axios.post('/api/get-all-products')
        if(data)
        {
           // console.log(data)
           var result = [];
           var count = 0;

           for(var i in data){
               count++;
           }
           setDataForAllProducts(data)
        }
        else{
            console.log('data error')
        }
      }
      catch
      {
        console.log('Error retrieving data...')
      }
      
  }
  useEffect(() => {
      getProductInfo();
  }, []);



    return(
        <>
        <Seo
          title="Parish Audio | Professional Audio Plugins"
          description="Discover Parish Audio plugins for mixing, sound design, songwriting, and modern production. Instant downloads for Mac and Windows."
          canonical="https://parishaudio.com/"
      />
        <div>
          <div className='dark-alpha-80'>
          <Paper
            ref={topContainer}
            sx={{
              position: 'relative',
              overflow: 'hidden',
              borderRadius: 3,
              mt:0,
              width:'95%',
              maxWidth:'1000px',
              margin:'auto',
              minHeight: { xs: 380, sm: 430, md: 470, lg: 520 },
              display: 'flex',
              alignItems: { xs: 'flex-end', md: 'center' },
              backgroundColor:'black',
              backgroundImage: {
                xs: `
                  linear-gradient(
                    90deg,
                    rgba(8, 12, 18, 0.92) 0%,
                    rgba(8, 12, 18, 0.82) 33%,
                    rgba(8, 12, 18, 0.48) 57%,
                    rgba(8, 12, 18, 0.20) 100%
                  ),
                  url('/assets/HeroBanner.png')
                `,
                md: `
                  linear-gradient(
                    90deg,
                    rgba(8, 12, 18, 0.92) 0%,
                    rgba(8, 12, 18, 0.82) 33%,
                    rgba(8, 12, 18, 0.48) 57%,
                    rgba(8, 12, 18, 0.20) 100%
                  ),
                  url('/assets/HeroBanner.png')
                `
              },
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
              >
            <Box
              sx={{
                width: '100%',
                p: { xs: 2, sm: 2.5, md: 3 },
                mt:'0px',
                mb:'0px',
                display: 'flex',
                alignItems: 'center',
              }}
            
            >
              <Box sx={{ maxWidth: { xs: '100%', md: 580 } }}>
                <Stack spacing={{ xs: 1.75, md: 2.25 }} alignItems="flex-start">
                  <Chip
                    label="Professional Audio Plugins"
                    sx={{
                      bgcolor: 'rgba(255,255,255,0.10)',
                      color: 'white',
                      fontWeight: 700,
                      backdropFilter: 'blur(6px)'
                    }}
                  />

                  <Typography
                    variant="h1"
                    sx={{
                      color: 'white',
                      fontWeight: 800,
                      lineHeight: 1.02,
                      fontSize: {
                        xs: '2.35rem',
                        sm: '3rem',
                        md: '4rem'
                      },
                      textShadow: '0 4px 24px rgba(0,0,0,0.45)'
                    }}
                  >
                    Parish Audio
                  </Typography>

                  <Typography
                    sx={{
                      color: 'rgba(255,255,255,0.92)',
                      fontWeight: 700,
                      lineHeight: 1.15,
                      fontSize: {
                        xs: '1.2rem',
                        sm: '1.45rem',
                        md: '2rem'
                      },
                      textShadow: '0 4px 24px rgba(0,0,0,0.4)'
                    }}
                  >
                    Powerful sound. Built for modern production.
                  </Typography>

                  <Typography
                    sx={{
                      color: 'rgba(255,255,255,0.82)',
                      fontWeight: 400,
                      maxWidth: 540,
                      fontSize: {
                        xs: '0.98rem',
                        sm: '1.05rem',
                        md: '1.2rem'
                      },
                      textShadow: '0 3px 18px rgba(0,0,0,0.4)'
                    }}
                  >
                    Explore creative tools for mixing, sound design, songwriting,
                    and everyday creative sessions. Available on Mac and Windows.
                  </Typography>

                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={1.5}
                    sx={{ pt: 0.5, width: { xs: '100%', sm: 'auto' } }}
                  >
                    <Button
                      variant="contained"
                      size="large"
                      component={RouterLink}
                      to="/plugins"
                      sx={{
                        bgcolor: 'white',
                        color: 'primary.main',
                        fontWeight: 700,
                        minWidth: { sm: 170 },
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.92)'
                        }
                      }}
                    >
                      Browse Plugins
                    </Button>

                    <Button
                      variant="outlined"
                      size="large"
                      component={RouterLink}
                      //to={featuredProduct ? `/products/${featuredProduct.productURI}` : '/products'}
                      to={`/products/d1-delay`}
                      sx={{
                        borderColor: 'rgba(255,255,255,0.40)',
                        color: 'white',
                        minWidth: { sm: 170 },
                        '&:hover': {
                          borderColor: 'rgba(255,255,255,0.65)',
                          bgcolor: 'rgba(255,255,255,0.06)'
                        }
                      }}
                    >
                      View Featured
                    </Button>
                  </Stack>

                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={{ xs: 0.75, sm: 2.5 }}
                    sx={{ pt: 0.5, flexWrap: 'wrap' }}
                  >
                    <Stack direction="row" spacing={1} alignItems="center">
                      <CheckCircleRounded sx={{ color: 'white' }} fontSize="small" />
                      <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)' }}>
                        Instant download
                      </Typography>
                    </Stack>

                    <Stack direction="row" spacing={1} alignItems="center">
                      <CheckCircleRounded sx={{ color: 'white' }} fontSize="small" />
                      <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)' }}>
                        VST3 plugins
                      </Typography>
                    </Stack>

                    <Stack direction="row" spacing={1} alignItems="center">
                      <CheckCircleRounded sx={{ color: 'white' }} fontSize="small" />
                      <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)' }}>
                        Mac + Windows
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Box>
            </Box>
          </Paper>
           <div className='centered-main-container' style={{display:'flex', flexDirection:'column', width:'95%', maxWidth:'900px', backgroundPosition: "center", minHeight:height - 130}}>


           <Box sx={{mt:1, backgroundColor:style.color1, borderRadius:'8px', p:0.25}}>
            <h2 style={{textAlign:'left', marginBottom:'0px', marginLeft:'30px'}}>
             Featured:
            </h2>
          {dataForAllProducts[2] && (
              <Box sx={{minWidth:'100px', backgroundColor:style.color1, m:1, mt:1, filter:'brightness(1.05)', boxShadow:4}}>

                   <HomeFeaturedProductCard productData={dataForAllProducts[3]} />
              </Box>
        )
      }
          </Box>

    <div style={{marginTop:'25px', marginBottom:'25px'}}>
      <SubscribeBanner />
    </div>

          <Box sx={{mt:2, backgroundColor:style.color1, borderRadius:'8px', p:1, mb:3}}>
            <h2 style={{textAlign:'left', marginBottom:'20px'}}>
              New Releases
            </h2>

          {!isMobile && dataForAllProducts.length > 0 && (
<>
           <Box sx={{ display:'flex', flexDirection:'row', p:1}}>
            <Box sx={{flex:1, margin:'10px', boxShadow:10, filter:'brightness(1.05)'}}>
              <HomePageProductCard productData={dataForAllProducts[0]} />
            </Box>
            <Box sx={{flex:1, margin:'10px', boxShadow:10, filter:'brightness(1.05)'}}>
              <HomePageProductCard productData={dataForAllProducts[1]} />
            </Box>
            <Box sx={{flex:1, margin:'10px', boxShadow:10, filter:'brightness(1.05)'}}>
              <HomePageProductCard productData={dataForAllProducts[2]} />
            </Box>


                
       </Box>
</>


          )}


      {isMobile && (
            
            <Box sx={{ display:'flex', flexDirection:'column'}}>
            {dataForAllProducts && dataForAllProducts.length > 0 ? (
  
              dataForAllProducts.map((product, index) => (
                <Box sx={{backgroundColor:style.color1, m:0.5, filter:'brightness(1.05)', boxShadow:10,p:1}}>
                     <HomePageProductCard key={index} productData={product} />
                </Box>
          ))
        ) : (
          <Box>
                  <LoadingSpinner />
          </Box>
        )}
        </Box>
 
 
 
           )}

          </Box>
          </div>
          </div>
          <div style={{width:'95%', maxWidth:'800px', margin:'auto', margin:'auto', textAlign:'center', marginBottom:'25px'}}>
            <h4 style={{marginBottom:'10px'}}>Find us on:</h4> 
            <a href="https://facebook.com/parishaudio" style={{paddingTop:'10px'}}><img src='FacebookIcon.png' alt="Facebook icon" style={{maxWidth:'33px', marginLeft:'12px'}} /></a>
            <a href="https://x.com/Parish_Audio"><img src='XLogoWhite.png'  alt="X icon"style={{maxWidth:'29px', marginLeft:'15px'}} /></a>
            <a href="https://youtube.com/@ParishAudio"><img src='YoutubeIcon.png' alt="Youtube icon" style={{maxWidth:'40px', marginLeft:'17px'}} /></a>
            </div>
        </div>
        
        </>
    )
}


// import {React, useState, useContext, useEffect, useRef} from "react"
// import {useStyle} from '../../context/styleContext/styleContext'

// //import{UserContext} from '../../context/userContext/userContext'
// //import { useStyle } from '../../context/styleContext/styleContext'
// import ReactGA from 'react-ga4';
// //import video from '../../videos/recording_video.mp4'
// import axios from 'axios'
// import { Helmet } from 'react-helmet';
// import {toast} from 'react-hot-toast'
// //import ProductCard from "../../components/ProductCard/ProductCard";
// //import ProductCardVertical from "../../components/ProductCard/ProductCardVertical";
// import Button from '@mui/material/Button';
// import Divider from '@mui/material/Divider';
// import { InfinityReverb_0_0_1 } from "../../ProductInfo";
// // import Card from '@mui/material/Card';
// // import CardActions from '@mui/material/CardActions';
// // import CardContent from '@mui/material/CardContent';
// // import CardMedia from '@mui/material/CardMedia';
// // import Typography from '@mui/material/Typography';
// import ProductCard from "../../components/ProductCard/ProductCard";
// import { Rating } from "@mui/material";
// import SubscribeBanner from "../../components/SubscribeBanner/SubscribeBanner";
// import HomePageProductCard from "../../components/ProductCard/HomePageProductCard";
// import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
// //import PageAnalytics from "../../components/PageAnalytics/PageAnalytics";
// //import SubscribeRedirectModal from "../../components/SubscribeRedirectModal/SubscribeRedirectModal";
// //import LoginSubscribePromptModal from "../../components/LoginSubscribePromptModal/LoginSubscribePromptModal";



// export default function Home(){

// //  const { user, userEmail, userFirstName, userLastName } = useContext(UserContext);
// //   const { isLoading } = useContext(UserContext);
//   const { style, setStyle } = useStyle();
//   //const { user } = useContext(UserContext);

//   const [width, setWidth] = useState(window.innerWidth)
//   const [height, setHeight] = useState(window.innerHeight)
//   const[productDataInfinityReverb, setProductDataInfinityReverb] = useState()
//   const[productDataInstagate, setProductDataInstagate] = useState()
//   const[productDataMK1Overdrive, setProductDataMK1Overdrive] = useState()
//   const[productData, setProductData] = useState([]);


// function handleWindowSizeChange() {
//     setWidth(window.innerWidth);
// }
// useEffect(() => {
//     window.addEventListener('resize', handleWindowSizeChange);
//     return () => {
//         window.removeEventListener('resize', handleWindowSizeChange);
//     }
// }, []);

// //const isMobile = width <= 768;
// const isMobile = true;

//   useEffect(() => {
//   document.title = 'Parish Audio | Cutting-Edge Audio Processing | Home';
//   const load = loadPageInfo()
//   //const loadData = loadProductDataToCards();
//   //const instagateData = loadInstagateToCard();
//   //const mk1OverdriveData = loadMK1OverdriveToCard();
// }, []);



// const topContainer = useRef();
//     useEffect(() => {
//         // To make sure page starts from the top
//         topContainer.current.scrollIntoView({ block: "end" });
//     }, []);


// const loadPageInfo= async (e) => {

//   try{
//     const {data} = await axios.post('/api/get-all-products')
//     if(data)
//     {
//        var result = [];
//        var count = 0;

//        for(var i in data){
//            count++;
//        }
//        setProductData(data)
//     }
//     else{
//         console.log('data error')
//     }
//   }
//   catch
//   {
//     console.log('Error retrieving data...')
//   }



// }


// const loadProductDataToCards = async (e) => {


//     //console.log("Loading Product Data....")
//       const productURI = 'infinity-reverb'
//       try{
//         const{data} = await axios.post('/get_product_page_info', {productURI})
//         if(data)
//         {
//             //console.log(data)
//             setProductDataInfinityReverb(data)
//             //console.log(data)
//             //document.title = 'Parish Audio | Cutting-Edge Audio Processing | ' + data.name;
            
//         }
//         else{
//             console.log('data error')
//         }
//       }
//       catch
//       {
//         console.log('Error retrieving data...')
//       }
      
//   }

//   const loadInstagateToCard = async (e) => {


//     //console.log("Loading Product Data....")
//       const productURI = 'instagate'
//       try{
//         const{data} = await axios.post('/get_product_page_info', {productURI})
//         if(data)
//         {
//             //console.log(data)
//             setProductDataInstagate(data)
//             //console.log(data)
//             //document.title = 'Parish Audio | Cutting-Edge Audio Processing | ' + data.name;
            
//         }
//         else{
//             console.log('data error')
//         }
//       }
//       catch
//       {
//         console.log('Error retrieving data...')
//       }
      
//   }

//   const loadMK1OverdriveToCard = async (e) => {


//     //console.log("Loading Product Data....")
//       const productURI = 'mk1-overdrive'
//       try{
//         const{data} = await axios.post('/get_product_page_info', {productURI})
//         if(data)
//         {
//             //console.log(data)
//             setProductDataMK1Overdrive(data)
//             //console.log(data)
//             //document.title = 'Parish Audio | Cutting-Edge Audio Processing | ' + data.name;
            
//         }
//         else{
//             console.log('data error')
//         }
//       }
//       catch
//       {
//         console.log('Error retrieving data...')
//       }
      
//   }




// // const topContainer = useRef();
// //     useEffect(() => {
// //         // To make sure page starts from the top
// //         topContainer.current.scrollIntoView({ block: "end" });
// //     }, []);



// useEffect(() => {
//   function handleResize() {      
//     setWidth(window.innerWidth)
//     setHeight(window.innerHeight)
// }

//   window.addEventListener('resize', handleResize)
// })


// const downloadMac = async (e) => {


//   e.preventDefault()
        
//         const dataToSend = {
//           sku: "10001",
//           productName: "Infinity Reverb",
//           productVersion: "Mac 0.0.1",
//           downloadURI: "/home",
//         }

//         console.log("attemting download")

//         try {
//           const { data } = await axios.post('/log-download-attempt', dataToSend);

//       } catch (error) {

//       }


//     window.location.href = '/MacVST3/InfinityReverb_0_0_1/InfinityReverb_0_0_1.pkg'
// }

// const downloadMK1Mac = async (e) => {


//   e.preventDefault()
        
//         const dataToSend = {
//           sku: "10003",
//           productName: "MK1 Overdrive",
//           productVersion: "Mac 0.0.1",
//           downloadURI: "/home",
//         }


//         try {
//           const { data } = await axios.post('/log-download-attempt', dataToSend);

//       } catch (error) {

//       }

//     window.location.href = '/MacVST3/MK1Overdrive_0_0_1/MK1Overdrive_0_0_1.pkg'
// }

// const downloadInstagateMac = async (e) => {


//   e.preventDefault()
        
//         const dataToSend = {
//           sku: "10002",
//           productName: "InstaGate NoiseGate",
//           productVersion: "Mac 0.0.1",
//           downloadURI: "/home",
//         }


//         try {
//           const { data } = await axios.post('/log-download-attempt', dataToSend);

//       } catch (error) {

//       }

//     window.location.href = '/MacVST3/InstaGate_0_0_1/InstaGate_0_0_1.pkg'
// }

// const downloadWindows = async (e) =>
//     {
//         //console.log("logging in...")

//         e.preventDefault()
        
//         const dataToSend = {
//           sku: "10001",
//           productName: "Infinity Reverb",
//           productVersion: "Windows 0.0.1",
//           downloadURI: "/home",
//         }

//         //console.log("attemting download")

//         try {
//           const { data } = await axios.post('/log-download-attempt', dataToSend);

//       } catch (error) {

//       }


//         window.location.href = '/WindowsVST3/InfinityReverb_0_0_1/Infinity-Reverb-v0_0_1-Windows-Installer.exe'


//     }

//     const downloadMK1Windows = async (e) =>
//       {
//           //console.log("logging in...")
  
//           e.preventDefault()
          
//           const dataToSend = {
//             sku: "10003",
//             productName: "MK1 Overdrive",
//             productVersion: "Windows 0.0.1",
//             downloadURI: "/home",
//           }
  
//           //console.log("attemting download")
  
//           try {
//             const { data } = await axios.post('/log-download-attempt', dataToSend);
  
//         } catch (error) {
  
//         }
  
  
//           window.location.href = '/WindowsVST3/MK1Overdrive_0_0_1/MK1Overdrive-v0_0_1-Windows-Installer.exe'
  
  
//       }


//       const downloadInstagateWindows = async (e) =>
//         {
//             //console.log("logging in...")
    
//             e.preventDefault()
            
//             const dataToSend = {
//               sku: "10002",
//               productName: "InstaGate NoiseGate",
//               productVersion: "Windows 0.0.1",
//               downloadURI: "/home",
//             }
    
//             //console.log("attemting download")
    
//             try {
//               const { data } = await axios.post('/log-download-attempt', dataToSend);
    
//            } catch (error) {
    
//             }
    
    
//             window.location.href = '/WindowsVST3/InstaGate_0_0_1/InstaGate-v0_0_1-Windows-Installer.exe'
    
    
//         }

//     return(
//         <>
// {!productData && 

// (<> 
//   <div ref={topContainer}>
//       <LoadingSpinner />


//   </div>
// </>)
// }

// {productData && (

// <div

// style={{
//   margin:'auto',
//   position: "relative",
//   width: "100%", // Full width
//   alignItems: "center",
//   display:'flex',
//   minHeight:height - 130,
//   justifyContent: "center",
//   textAlign: "center",
//   flex:1,
//   marginBottom:'0px',
//   color: style.color4, // Ensure text is visible
//   backgroundColor:'black',
//   backgroundImage: `url("/RecordingStudioStockImage1.jpg")`,
//   backgroundSize: "cover",
//   backgroundPosition: "center",
// }}
// >
// <div
//   style={{

//     flex:1,
//     backgroundColor: "rgba(0, 0, 0, 0.7)", // 50% transparent black overlay
//     minHeight:height - 130,
//     borderWidth:'3px',
//     display: "flex",
//     flexDirection:'column', 
//     padding:'0px'
//   }}
// >
// <div style={{width:'95%', maxWidth:'600px', margin:'auto', marginTop:'25px'}}>
//     <h1 ref={topContainer} style={{textAlign:'left', marginBottom:'25px'}}>New Releases</h1>
//     <Divider /> 


// { productData && productData.length > 0 && (

//   productData.map((product, index) => (

//          <HomePageProductCard key={index} productData={product} />
// ))
// )}

   



// {isMobile && (
// <>

//   <div className='mobile-card-outer-container'>
//         <div className='mobile-card-left-panel'>
//           <h2 className='mobile-card-product-title'>
//           <a href={'/products/infinity-reverb'}>
//             Infinity Reverb
//           </a>
//           </h2>

//           <div className='mobile-card-rating-container'>

//           <div className='mobile-card-stars-box'>
//           <a href={'/reviews/infinity-reverb'} style={{margin:'auto'}}> 

//           <Rating className='mobile-card-rating' name="read-only" precision={0.5} value={5} readOnly/>
//           </a>
//           </div>
//           <div className='mobile-card-rating-count-box'>
//               <a href={'/reviews/infinity-reverb'}> 

//                   (1 review)

//               </a>
//           </div>

//           </div>
//           <div className='mobile-card-short-description'>
//           The Infinity reverb is an ultra clean reverb designed specifically for guitar.
//         </div>

//           <div className='mobile-audio-player-container'>
//                 <audio controls className='mobile-audio-player'>  
//                           <source src="InfinityReverb.mp3" type="audio/mp3" size='small'  />              
//                 </audio>
//          </div>

        
//         <div>
//         <Divider variant="middle" className='mobile-card-divider' />
//         </div>
//         <div className='mobile-card-download-call-to-action'>
//         <a href={'/products/infinity-reverb'}>
          
//           Download VST3 Plugin </a></div>

//           <div style={{display:'flex', flexDirection:'column', flex:1}}>
//             <div style={{ flex:2}}>
//             <strong><a href={'/products/infinity-reverb'} className='mobile-card-free-link'> FREE! </a>
//             </strong>
//             </div>
//             <div style={{display:'flex', flexDirection:'row', flex:1, padding:'5px', minWidth:'150px'}}>
//               <div style={{flex:1, minHeight:'100%'}}>
//                 <Button  sx={{color:style.color4}} size="medium" onClick={downloadWindows}>
//                   <div style={{display:'flex', flexDirection:'column'}}>
//                     <div>
//                     <img src='/windows_logo.png' alt="Blue Windows logo" className='mobile-card-windows-download-button-image' />

//                     </div>
//                     <div>
//                     <strong>Windows</strong>
//                     </div>
//                   </div>
//                 </Button>
//               </div>
//               <div style={{flex:1, minHeight:'100%'}}>
//                 <Button  sx={{color:style.color4}} size="medium" onClick={downloadMac}>
//                   <div style={{display:'flex', flexDirection:'column'}}>
//                     <div style={{ backgroundColor:style.color4, padding:'5px'}}>
//                     <img src='/apple_logo.svg' alt="Black Apple logo on a white background" className='mobile-card-mac-download-button-image'/>

//                     </div>
//                     <div>
//                     <strong>Mac</strong>
//                     </div>
//                   </div>
//                 </Button>
//               </div>
//             </div>
//           </div>

//         </div>
//         <div className = 'mobile-card-right-panel'>
//           <a href={'/products/infinity-reverb'}>
//           <img className='mobile-card-image' src="InfinityReverb_small.png" alt="Parish Audio Infinity Reverb – a VST3 plugin designed to replicate a guitar reverb stompbox. The interface features a black, speckled pedal design with silver knobs labeled Size, Width, Damping, Wet, and Dry. A glowing blue LED is positioned in the center, indicating power. The pedal's name, 'Infinity Reverb,' is displayed in a stylized metallic font with an infinity symbol integrated into the design. Below, a touch-sensitive on/off switch is marked with a waveform icon. The 'Parish Audio' logo is subtly highlighted in blue." />
//           </a>
//         </div>

//     </div>



//     <div className='mobile-card-outer-container'>
//         <div className='mobile-card-left-panel'>
//           <h2 className='mobile-card-product-title'>
//           <a href={'/products/mk1-overdrive'}>
//             MK1 Overdrive
//           </a>
//           </h2>

//           <div className='mobile-card-rating-container'>

//           <div className='mobile-card-stars-box'>
//           <a href={'/reviews/infinity-reverb'} style={{margin:'auto'}}> 

//           <Rating className='mobile-card-rating' name="read-only" precision={0.5} readOnly/>
//           </a>
//           </div>
//           <div className='mobile-card-rating-count-box'>
//               <a href={'/reviews/mk1-overdrive'}> 

//                   (0 reviews)

//               </a>
//           </div>

//           </div>
//           <div className='mobile-card-short-description'>
//           Classic Overdrive tone with plenty of headroom.
//         </div>

//           <div className='mobile-audio-player-container'>
//                 {/* <audio controls className='mobile-audio-player'>  
//                           <source src="InfinityReverb.png" type="audio/mp3" size='small'  />              
//                 </audio> */}
//          </div>

        
//         <div>
//         <Divider variant="middle" className='mobile-card-divider' />
//         </div>
//         <div className='mobile-card-download-call-to-action'>
//         <a href={'/products/mk1-overdrive'}>
          
//           Download VST3 Plugin </a></div>

//           <div style={{display:'flex', flexDirection:'column', flex:1}}>
//             <div style={{ flex:2}}>
//             <strong><a href={'/products/mk1-overdrive'} className='mobile-card-free-link'> FREE! </a>
//             </strong>
//             </div>
//             <div style={{display:'flex', flexDirection:'row', flex:1, padding:'5px', minWidth:'150px'}}>
//               <div style={{flex:1, minHeight:'100%'}}>
//                 <Button  sx={{color:style.color4}} size="medium" onClick={downloadMK1Windows}>
//                   <div style={{display:'flex', flexDirection:'column'}}>
//                     <div>
//                     <img src='/windows_logo.png' alt="Blue Windows logo" className='mobile-card-windows-download-button-image' />

//                     </div>
//                     <div>
//                     <strong>Windows</strong>
//                     </div>
//                   </div>
//                 </Button>
//               </div>
//               <div style={{flex:1, minHeight:'100%'}}>
//                 <Button  sx={{color:style.color4}} size="medium" onClick={downloadMK1Mac}>
//                   <div style={{display:'flex', flexDirection:'column'}}>
//                     <div style={{ backgroundColor:style.color4, padding:'5px'}}>
//                     <img src='/apple_logo.svg' alt="Black Apple logo on a white background" className='mobile-card-mac-download-button-image'/>

//                     </div>
//                     <div>
//                     <strong>Mac</strong>
//                     </div>
//                   </div>
//                 </Button>
//               </div>
//             </div>
//           </div>

//         </div>
//         <div className = 'mobile-card-right-panel'>
//           <a href={'/products/mk1-overdrive'}>
//           <img className='mobile-card-image' src="MK1Overdrive_small.png" alt="MK-1 Overdrive – a VST3 plugin designed to replicate a guitar overdrive stompbox. The interface features a metallic green, glittery pedal design with three silver knobs labeled 'Drive,' 'Tone,' and 'Level,' each set to 5.5. A red LED indicator at the top signals that the effect is active. The pedal’s name, 'MK-1 Overdrive,' is prominently displayed in bold metallic lettering, with 'Parish Audio' written in blue underneath. Below, a large touch-sensitive on/off switch is featured, displaying a waveform icon. This design mimics classic overdrive pedals, offering warm and dynamic distortion for guitarists." />
//           </a>
//         </div>

//     </div>

//   <div className='mobile-card-outer-container'>
//         <div className='mobile-card-left-panel'>
//           <h2 className='mobile-card-product-title'>
//           <a href={'/products/instagate'}>
//             Instagate Noisegate
//           </a>
//           </h2>

//           <div className='mobile-card-rating-container'>

//           <div className='mobile-card-stars-box'>
//           <a href={'/reviews/infinity-reverb'} style={{margin:'auto'}}> 

//           <Rating className='mobile-card-rating' name="read-only" precision={0.5} readOnly/>
//           </a>
//           </div>
//           <div className='mobile-card-rating-count-box'>
//               <a href={'/reviews/mk1-overdrive'}> 

//                   (0 reviews)

//               </a>
//           </div>

//           </div>
//           <div className='mobile-card-short-description'>
//           The Instagate Noisegate is an ultra fast acting noisegate for guitar.
//         </div>

//           <div className='mobile-audio-player-container'>
//                 {/* <audio controls className='mobile-audio-player'>  
//                           <source src="InfinityReverb.png" type="audio/mp3" size='small'  />              
//                 </audio> */}
//          </div>

        
//         <div>
//         <Divider variant="middle" className='mobile-card-divider' />
//         </div>
//         <div className='mobile-card-download-call-to-action'>
//         <a href={'/products/mk1-overdrive'}>
          
//           Download VST3 Plugin </a></div>

//           <div style={{display:'flex', flexDirection:'column', flex:1}}>
//             <div style={{ flex:2}}>
//             <strong><a href={'/products/instagate'} className='mobile-card-free-link'> FREE! </a>
//             </strong>
//             </div>
//             <div style={{display:'flex', flexDirection:'row', flex:1, padding:'5px', minWidth:'150px'}}>
//               <div style={{flex:1, minHeight:'100%'}}>
//                 <Button  sx={{color:style.color4}} size="medium" onClick={downloadInstagateWindows}>
//                   <div style={{display:'flex', flexDirection:'column'}}>
//                     <div>
//                     <img src='/windows_logo.png' alt="Blue Windows logo" className='mobile-card-windows-download-button-image' />

//                     </div>
//                     <div>
//                     <strong>Windows</strong>
//                     </div>
//                   </div>
//                 </Button>
//               </div>
//               <div style={{flex:1, minHeight:'100%'}}>
//                 <Button  sx={{color:style.color4}} size="medium" onClick={downloadInstagateMac}>
//                   <div style={{display:'flex', flexDirection:'column'}}>
//                     <div style={{ backgroundColor:style.color4, padding:'5px'}}>
//                     <img src='/apple_logo.svg' alt="Black Apple logo on a white background" className='mobile-card-mac-download-button-image'/>

//                     </div>
//                     <div>
//                     <strong>Mac</strong>
//                     </div>
//                   </div>
//                 </Button>
//               </div>
//             </div>
//           </div>

//         </div>
//         <div className = 'mobile-card-right-panel'>
//           <a href={'/products/instagate'}>
//           <img className='mobile-card-image' src="Instagate_small.png" alt="Insta-Gate Ultra Fast Noise Gate – a VST3 plugin designed to replicate a guitar noise gate pedal. The interface features a bright red stompbox-style design with a single large white knob labeled 'Threshold,' marked with values ranging from -100 dB to 0 dB. A digital display below the knob shows the current threshold setting of -42.0 dB. The pedal has 'IN' and 'OUT' labels on the sides for signal flow representation. A glowing red LED at the top indicates that the pedal is active. Below the threshold knob, a large touch-sensitive on/off switch is displayed, featuring a waveform icon. The name 'Insta-Gate' is prominently displayed in bold red font, with the tagline 'Ultra Fast Noisegate' beneath it." />
//           </a>
//         </div>
//     </div>




// </>

// )}


// </div>
// <div style={{marginTop:'10px'}}>
//   <SubscribeBanner />
//   </div>
// <div style={{marginTop:"20px", marginBottom:'35px'}}><a href="/plugins"> <strong>Shop All Products</strong></a></div>
//   </div>




// </div>


// )}
        



        






        
//         </>

//     )
// }